<template>
  <div>
    <b-form-group
      id="emailCpf"
      label-for="input-emailCpf"
      :invalid-feedback="inputInvalid"
      :label="label"
      :class="col"
    >
      <b-form-input 
        id="input-emailCpf"
        v-model="emailCpf"
        v-mask="mask"
        @input="maskCPF"
        @blur="validaCampo"
        :state="state"
        :placeholder="inputText" 
        :disabled="disabled"
        autocomplete="off"
        trim
      >
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      label: String, // para dar nome ao campo
      inputText: String, // placeholder
      inputInvalid: String, // mensagem para campo invalido
      col: String, // definindo o tamanho do input na tela de acordo com cada caso
      disabled: Boolean, //para abilitar ou desabilitar o campo
      filtro: String, // envia dados do componente pai para o filho
      validado: Boolean // controla a cor dos campos
    },

    created(){
      if(this.filtro){
        this.emailCpf = this.filtro
      }
    },

    computed: {
      state() {
        if((this.validado || this.validado === false) && (this.estado === null || this.estado === false)){
          return this.validado
        }
        return this.estado
      }
    },

    data() {
      return {
        emailCpf: '',
        emailCpfSemMascara: '',
        tipoDeDado: '',
        mask: '',
        usuario: '',
        dominio: '',
        estado: null
      }
    },

    methods: {
      maskCPF() {
        this.mask = "";
        this.emailCpfSemMascara = this.emailCpf.replace(/\W/g, "");
        this.tipoDeDado = this.verificaDigitos(this.emailCpfSemMascara)
        if (this.tipoDeDado == "email") {
          this.mask = "";
          return
        } else {
          this.mask = "XXX.XXX.XXX-XX";
          return
        }
      },

      validaCampo(){
        this.maskCPF()
        if(this.emailCpf.length === 0){ // o campo só ira pintar se tiver algo no input
          this.estado = null;
          return false;
        }
        if(this.tipoDeDado == "email"){
          this.estado = this.validacaoEmail(this.emailCpf)
        } else {
          this.verificaCPF(this.emailCpfSemMascara)
        }
        if(this.estado){
          return true;
        }else{
          return false;
        }

      },

      verificaCPF(cpf){
        if (cpf == "00000000000" ||
          cpf == "11111111111" ||
          cpf == "22222222222" ||
          cpf == "33333333333" ||
          cpf == "44444444444" ||
          cpf == "55555555555" ||
          cpf == "66666666666" ||
          cpf == "77777777777" ||
          cpf == "88888888888" ||
          cpf == "99999999999"
        ){
          this.estado = false
        } else {
          this.estado = this.validaCPF(cpf)
        }
      },

      validaCPF(cpf){
        var soma = 0;
        var resto;
        for (var i = 1; i <= 9; i++)
          soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cpf.substring(9, 10)))
          return false;
        soma = 0;
        for (i = 1; i <= 10; i++)
          soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        resto = (soma * 10) % 11;
        if (resto == 10 || resto == 11) resto = 0;
        if (resto != parseInt(cpf.substring(10, 11)))
          return false;
        this.$emit("emitindoEmailCpf", this.emailCpf); 
        return true;
      },

      validacaoEmail(email) {
        this.usuario = email.substring(0, email.indexOf("@"));
        this.dominio = email.substring(email.indexOf("@")+ 1, email.length);

        if ((this.usuario.length >=1) &&
            (this.dominio.length >=3) &&
            (this.usuario.search("@")==-1) &&
            (this.dominio.search("@")==-1) &&
            (this.usuario.search(" ")==-1) &&
            (this.dominio.search(" ")==-1) &&
            (this.dominio.search(".")!=-1) &&
            (this.dominio.indexOf(".") >=1)&&
            (this.dominio.lastIndexOf(".") < this.dominio.length - 1)) 
        {
          this.$emit("emitindoEmailCpf", this.emailCpf); 
          return true
        } else {
          if(this.emailCpf.length === 0){ // verificando novamente o input para pintar o campo
            return null
          } else { // se já estiver com dados no input e não estiver válido ira pintar de vermelho
          return false
          }
        }
      },

      verificaDigitos(emailOuCpf){
        if (isNaN(emailOuCpf) === true) {
          return "email";
        } else {
          return "cpf";
        }
      }
    }

  }
</script>